import React, { useCallback, useMemo } from "react";

import cx from "classnames";

import { zindexDropdown } from "~/css/zindexes";
import fellowSelectProps from "~/ui/react-select";
import Selector, { type SelectorOption } from "~/ui/selectors/Selector";

import styles from "./Asana.module.css";

export interface WorkspaceOption {
	label: string;
	value: string;
}

export interface WorkspaceSelectorProps {
	value?: string;
	options: WorkspaceOption[];
	onChange: (value: string) => void;
	className?: string;
}

export function WorkspaceSelector({ value, options, onChange, className }: WorkspaceSelectorProps) {
	const ellipses = {
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis",
		textAlign: "left",
	} as const;

	const selectedOption = useMemo(() => options.find(option => option.value === value), [value, options]);

	const handleChange = useCallback(
		(newValue: SelectorOption | null) => {
			if (newValue) {
				onChange(newValue.value);
			}
		},
		[onChange],
	);

	return (
		<Selector
			{...fellowSelectProps}
			options={options}
			value={selectedOption}
			onChange={handleChange}
			placeholder="Select a workspace"
			className={cx(fellowSelectProps.className, styles.select, className)}
			styles={{ option: base => ({ ...base, ...ellipses }), menuPortal: base => ({ ...base, zIndex: zindexDropdown }) }}
			menuPortalTarget={document.body}
			menuPosition="fixed"
		/>
	);
}
